import api from 'app/api';
import { ZohoCustomerUnpaidBillsSummaryResponse } from '@heltarchat/shared';

/**
 * Lightweight unpaid summary for the app-wide banner (PENDING + FAILED).
 * GET /v1/business/billing/zoho-customer-bills/unpaid-summary
 */
export const getCustomerZohoBillsUnpaidSummary =
  async (): Promise<ZohoCustomerUnpaidBillsSummaryResponse> => {
    const response = await api.get(
      '/business/billing/zoho-customer-bills/unpaid-summary',
    );

    return response?.data?.data;
  };
